import script from "./MockMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./MockMenu.vue?vue&type=script&setup=true&lang=js"

import "./MockMenu.vue?vue&type=style&index=0&id=14f43fd2&lang=css"

const __exports__ = script;

export default __exports__